module.exports = __webpack_public_path__ + "images/c9baefb83e77e4fdc3b65f72b79dc507.png";